"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsBICValidator = void 0;
exports.isBIC = isBIC;
const class_validator_1 = require("class-validator");
const BICRegex = /^[a-z]{4}[a-z]{2}[a-z0-9]{2}([a-z0-9]{3}|)$/i;
let IsBICValidator = class IsBICValidator {
    validate(rawBIC) {
        return isBIC(rawBIC);
    }
    defaultMessage() {
        return "BIC is in wrong format.";
    }
};
exports.IsBICValidator = IsBICValidator;
exports.IsBICValidator = IsBICValidator = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "is BIC" })
], IsBICValidator);
function isBIC(rawBIC) {
    if (!rawBIC) {
        return false;
    }
    const l = rawBIC.length;
    if (l !== 8 && l !== 11) {
        return false;
    }
    return BICRegex.test(rawBIC);
}
//# sourceMappingURL=IsBICValidator.js.map